// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"fb52aac9","71":"7d7675ae","78":"b7d3e779","369":"f42c6bb4","515":"c0db3684","522":"d512d78a","569":"fdc91bfe","680":"363408da","852":"1ef05045","894":"2f6a3edf","987":"31eb7137"}[chunkId] + ".chunk.js";
};